import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = 'https://cotizaciones-fabrica-rivera-production.up.railway.app/api';


const TIPOS_DOC = ['NIT', 'CC', 'CE', 'Pasaporte'];

export default function Clientes() {
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };
  const [clientes, setClientes] = useState([]);
  const [form, setForm] = useState({ razon_social:'', nit:'', tipo_documento:'NIT', email:'', telefono:'', ciudad:'', direccion:'', contacto:'' });
  const [editandoId, setEditandoId] = useState(null);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [busqueda, setBusqueda] = useState('');

  const clientesFiltrados = clientes.filter(c => {
    const q = busqueda.trim().toLowerCase();
    if (!q) return true;
    return [c.razon_social, c.nit, c.ciudad, c.contacto, c.email, c.telefono]
      .some(campo => (campo || '').toLowerCase().includes(q));
  });

  const cargar = () => axios.get(`${API}/clientes`, { headers }).then(r => setClientes(r.data));
  useEffect(() => { cargar(); }, []);

  const abrirNuevo = () => {
    setForm({ razon_social:'', nit:'', tipo_documento:'NIT', email:'', telefono:'', ciudad:'', direccion:'', contacto:'' });
    setEditandoId(null);
    setMostrarForm(true);
  };

  const abrirEditar = (c) => {
    setForm({
      razon_social: c.razon_social, nit: c.nit, tipo_documento: c.tipo_documento || 'NIT',
      email: c.email||'', telefono: c.telefono||'', ciudad: c.ciudad||'',
      direccion: c.direccion||'', contacto: c.contacto||''
    });
    setEditandoId(c.id);
    setMostrarForm(true);
  };

  const guardar = async () => {
    try {
      if (editandoId) {
        await axios.put(`${API}/clientes/${editandoId}`, form, { headers });
      } else {
        await axios.post(`${API}/clientes`, form, { headers });
      }
      setForm({ razon_social:'', nit:'', tipo_documento:'NIT', email:'', telefono:'', ciudad:'', direccion:'', contacto:'' });
      setEditandoId(null);
      setMostrarForm(false);
      cargar();
    } catch(err) {
      alert('Error: ' + (err.response?.data?.error || err.message));
    }
  };

  const cancelar = () => {
    setMostrarForm(false);
    setEditandoId(null);
    setForm({ razon_social:'', nit:'', tipo_documento:'NIT', email:'', telefono:'', ciudad:'', direccion:'', contacto:'' });
  };

  return (
    <div style={s.page}>
      <div style={s.header} className="rf-header">
        <button style={s.btnVolver} onClick={() => window.location.href='/'}>← Volver</button>
        <h1 style={s.titulo}>Clientes</h1>
        <button style={s.btnNuevo} onClick={abrirNuevo}>+ Nuevo Cliente</button>
      </div>

      {mostrarForm && (
        <div style={s.formCard}>
          <h3 style={s.cardTitulo}>{editandoId ? 'Editar Cliente' : 'Nuevo Cliente'}</h3>
          <div style={s.grid2} className="rf-grid2">
            <div>
              <label style={s.label}>Razón Social</label>
              <input style={s.input} value={form.razon_social} onChange={e => setForm({...form, razon_social: e.target.value})} />
            </div>
            <div>
              <label style={s.label}>Tipo de Documento</label>
              <select style={s.input} value={form.tipo_documento} onChange={e => setForm({...form, tipo_documento: e.target.value})}>
                {TIPOS_DOC.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div>
              <label style={s.label}>Número de Documento</label>
              <input style={s.input} value={form.nit} onChange={e => setForm({...form, nit: e.target.value})} />
            </div>
            <div>
              <label style={s.label}>Email</label>
              <input style={s.input} value={form.email} onChange={e => setForm({...form, email: e.target.value})} />
            </div>
            <div>
              <label style={s.label}>Teléfono</label>
              <input style={s.input} value={form.telefono} onChange={e => setForm({...form, telefono: e.target.value})} />
            </div>
            <div>
              <label style={s.label}>Ciudad</label>
              <input style={s.input} value={form.ciudad} onChange={e => setForm({...form, ciudad: e.target.value})} />
            </div>
            <div>
              <label style={s.label}>Dirección</label>
              <input style={s.input} value={form.direccion} onChange={e => setForm({...form, direccion: e.target.value})} />
            </div>
            <div>
              <label style={s.label}>Contacto</label>
              <input style={s.input} value={form.contacto} onChange={e => setForm({...form, contacto: e.target.value})} />
            </div>
          </div>
          <div style={s.botonesForm}>
            <button style={s.btnCancelar} onClick={cancelar}>Cancelar</button>
            <button style={s.btnGuardar} onClick={guardar}>{editandoId ? 'Actualizar' : 'Guardar'}</button>
          </div>
        </div>
      )}

      <div style={s.container} className="rf-container">
        <input
          type="text"
          style={s.busqueda}
          placeholder="🔍 Buscar por razón social, documento, ciudad, contacto..."
          value={busqueda}
          onChange={e => setBusqueda(e.target.value)}
        />
        <div className="rf-tabla-wrap">
        <table style={s.tabla}>
          <thead>
            <tr style={s.theadRow}>
              <th style={s.th} className="rf-th">Razón Social</th>
              <th style={s.th} className="rf-th">Tipo Doc.</th>
              <th style={s.th} className="rf-th">Documento</th>
              <th style={s.th} className="rf-th">Ciudad</th>
              <th style={s.th} className="rf-th">Teléfono</th>
              <th style={s.th} className="rf-th">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {clientesFiltrados.length === 0 && (
              <tr><td colSpan="6" style={{ padding:'2rem', textAlign:'center', color:'#aaa' }}>No se encontraron clientes</td></tr>
            )}
            {clientesFiltrados.map(c => (
              <tr key={c.id} style={s.row}>
                <td style={s.td} className="rf-td">{c.razon_social}</td>
                <td style={s.td} className="rf-td">{c.tipo_documento || 'NIT'}</td>
                <td style={s.td} className="rf-td">{c.nit}</td>
                <td style={s.td} className="rf-td">{c.ciudad}</td>
                <td style={s.td} className="rf-td">{c.telefono}</td>
                <td style={s.td} className="rf-td">
                  <button style={s.btnEditar} onClick={() => abrirEditar(c)}>Editar</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
}

const s = {
  page:       { minHeight:'100vh', background:'#f5f5f5' },
  header:     { background:'#1a1a2e', padding:'1rem 2rem', display:'flex', justifyContent:'space-between', alignItems:'center' },
  titulo:     { color:'#c8a951', fontSize:'20px', fontWeight:'700' },
  btnVolver:  { background:'transparent', color:'#aaa', border:'1px solid #aaa', padding:'8px 14px', borderRadius:'8px' },
  btnNuevo:   { background:'#c8a951', color:'#fff', border:'none', padding:'8px 16px', borderRadius:'8px', fontWeight:'600' },
  formCard:   { background:'#fff', margin:'1.5rem', padding:'1.5rem', borderRadius:'10px', boxShadow:'0 2px 8px rgba(0,0,0,0.07)' },
  cardTitulo: { fontSize:'16px', fontWeight:'700', color:'#1a1a2e', marginBottom:'1rem', borderBottom:'2px solid #c8a951', paddingBottom:'6px' },
  grid2:      { display:'grid', gridTemplateColumns:'1fr 1fr', gap:'1rem', marginBottom:'1rem' },
  label:      { display:'block', fontSize:'13px', color:'#666', marginBottom:'4px' },
  input:      { width:'100%', padding:'9px 12px', border:'1px solid #ddd', borderRadius:'6px', fontSize:'14px' },
  botonesForm:{ display:'flex', gap:'12px', justifyContent:'flex-end' },
  btnCancelar:{ background:'transparent', color:'#888', border:'1px solid #ddd', padding:'10px 24px', borderRadius:'8px' },
  btnGuardar: { background:'#1a1a2e', color:'#fff', border:'none', padding:'10px 24px', borderRadius:'8px', fontWeight:'600' },
  btnEditar:  { background:'#1a1a2e', color:'#fff', border:'none', padding:'6px 14px', borderRadius:'6px', fontSize:'13px' },
  container:  { padding:'1.5rem' },
  busqueda:   { width:'100%', maxWidth:'420px', padding:'10px 14px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', marginBottom:'1rem', display:'block', background:'#fff' },
  tabla:      { width:'100%', borderCollapse:'collapse', background:'#fff', borderRadius:'10px', overflow:'hidden', boxShadow:'0 2px 8px rgba(0,0,0,0.08)' },
  theadRow:   { background:'#1a1a2e' },
  th:         { padding:'12px 16px', color:'#c8a951', textAlign:'left', fontSize:'13px', fontWeight:'600' },
  row:        { borderBottom:'1px solid #f0f0f0' },
  td:         { padding:'12px 16px', fontSize:'14px' },
};